import Swiper, { Navigation, Pagination, Autoplay, EffectFade, Lazy } from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Lazy]);
export default class Carousel {
    constructor() {
        this.defaultConfig = {
            direction: 'horizontal',
            watchOverflow: true,
            centeredSlides: true,
            grabCursor: true,
            fadeEffect: { crossFade: true },
            autoplay: {
                delay: 5000,
            },
            loop: true,
            lazy: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            // And if we need scrollbar
            scrollbar: {
                el: '.swiper-scrollbar',
            }
        };
        document.addEventListener('DOMContentLoaded', () => { this.init(); });
    }
    init() {
        this.initSwiper();
    }
    initSwiper() {
        let heroSwipers = document.querySelectorAll('.hero-swiper, .content-swiper');
        if (heroSwipers.length > 0) {
            for (var i = 0; i < heroSwipers.length; i++) {
                var hero = heroSwipers[i];
                var slides = hero.querySelectorAll('.swiper-slide');
                if (slides.length > 1) {
                    let configAttributes = hero.getAttribute("swiper-config");
                    let config = configAttributes ? JSON.parse(configAttributes) : {};
                    let swiperConfig = Object.assign(this.defaultConfig, config);
                    let mySwiper = new Swiper(hero, swiperConfig);
                }
            }
        }
        let timeline = document.querySelectorAll(".timeline.timeline-horizontal .swiper-container");
        if (timeline.length > 0) {
            for (let i = 0; i < timeline.length; i++) {
                let item = timeline[i];
                let s = new Swiper(item, {
                    direction: 'horizontal',
                    watchOverflow: true,
                    centeredSlides: true,
                    grabCursor: true,
                    fadeEffect: { crossFade: true },
                    autoplay: false,
                    loop: true,
                    lazy: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<div class="' + className + '">' + (index + 1) + '</div>';
                        },
                    },
                });
            }
            ;
        }
    }
}
